import React from 'react';
import PropTypes from 'prop-types';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import FormatDollarAmount from './FormatDollarAmount.jsx';

function YearOverYearRow({ yearOverYearNetSale }) {
  return (
    <TableRow>
      <TableCell data-cy={`bucket-${yearOverYearNetSale.ProductGroup}`}>
        {yearOverYearNetSale.ProductGroup}
      </TableCell>
      <TableCell data-cy={`netsales-previous-${yearOverYearNetSale.ProductGroup}`}>
        <FormatDollarAmount amount={yearOverYearNetSale.PreviousYearNetSales} />
      </TableCell>
      <TableCell data-cy={`netsales-current-${yearOverYearNetSale.ProductGroup}`}>
        <FormatDollarAmount amount={yearOverYearNetSale.CurrentYearNetSales} />
      </TableCell>
      <TableCell data-cy={`netsales-change-${yearOverYearNetSale.ProductGroup}`}>
        {yearOverYearNetSale.Change > 0 ? (
          <ArrowUpwardIcon
            data-cy={`netsales-growth-${yearOverYearNetSale.ProductGroup}-up`}
            sx={{ color: 'green', verticalAlign: 'middle', fontSize: 'small' }}
          />
        ) : (
          <ArrowDownwardIcon
            data-cy={`netsales-growth-${yearOverYearNetSale.ProductGroup}-down`}
            sx={{ color: 'red', verticalAlign: 'middle', fontSize: 'small' }}
          />
        )}
        <FormatDollarAmount amount={yearOverYearNetSale.Change} />
      </TableCell>
    </TableRow>
  );
}

YearOverYearRow.propTypes = {
  yearOverYearNetSale: PropTypes.shape({
    ProductGroup: PropTypes.string.isRequired,
    PreviousYearNetSales: PropTypes.number.isRequired,
    CurrentYearNetSales: PropTypes.number.isRequired,
    Change: PropTypes.number.isRequired,
  }).isRequired,
};

export default React.memo(YearOverYearRow);
